import { makeStyles } from '@mui/styles';
import backgroundPrincipal from '../../../assets/images/background_principal.png'

const useStyles = makeStyles({
  section: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px',
    margin: '0 auto',
    textAlign: 'justify',
    height: "100vh", // Altura completa del viewport
    backgroundImage: `url(${backgroundPrincipal})`,
    backgroundSize: "cover", // Asegura que la imagen cubra todo el contenedor
    backgroundPosition: "center", // Centra la imagen
    backgroundRepeat: "no-repeat", // Evita que la imagen se repita
    "@media (max-width: 768px)": {
      padding: '20px',
    },
  },
  textContainer: {
    width: '70%',
    "@media (max-width: 1540px)": {
      width: '70%'
    },
    "@media (max-width: 1280px)": {
      width: '80%'
    },
    "@media (max-width: 1023px)": {
      width: '90%'
    },
    "@media (max-width: 768px)": {
      width: '95%'
    },
  },
  heading: {
    marginBottom: '20px',
    color: '#ffffff',
    fontSize: '64px',
    textAlign: 'left',
    "@media (max-width: 1540px)": {
      fontSize: '60px',
    },
    "@media (max-width: 1280px)": {
      fontSize: '58px',
    },
    "@media (max-width: 1023px)": {
      fontSize: '52px',
    },
    "@media (max-width: 768px)": {
      fontSize: '48px',
    },
    "@media (max-width: 600px)": {
      fontSize: '42px',
    },
    "@media (max-width: 480px)": {
      fontSize: '40px',
    },
    "@media (max-width: 400px)": {
      fontSize: '32px',
    },
  },
  paragraph: {
    textAlign: 'left',
    color: '#ffffff',
    fontSize: '28px',
    "@media (max-width: 1540px)": {
      fontSize: '26px',
    },
    "@media (max-width: 1280px)": {
      fontSize: '24px',
    },
    "@media (max-width: 1023px)": {
      fontSize: '22px',
    },
    "@media (max-width: 768px)": {
      fontSize: '20px',
    },
    "@media (max-width: 600px)": {
      fontSize: '18px',
    },
  },
  imageContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
  },
  button: {
    marginTop: '20px',
    fontSize: '20px !important',
    textTransform: 'none !important',
    color: '#1356DA !important',
    fontWeight: 'bold !important',
    backgroundColor: 'white !important',
    '&:hover': {
      backgroundColor: 'transparent !important',
      color: 'white !important',
      border: '1px solid white'
    },
    "@media (max-width: 1540px)": {
      fontSize: '18px !important',
    },
    "@media (max-width: 1280px)": {
      fontSize: '17px !important',
    },
    "@media (max-width: 1023px)": {
      fontSize: '16px !important',
    },
    "@media (max-width: 768px)": {
      fontSize: '15px !important',
    },
    "@media (max-width: 600px)": {
      fontSize: '14px !important',
    },
    "@media (max-width: 480px)": {
      fontSize: '13px !important',
    },
    "@media (max-width: 400px)": {
      fontSize: '12px !important',
    },
  },
  cardsContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '30px',
    gap: '20px',
  },
  card: {
    width: '22%',
    background: 'linear-gradient(142deg, rgba(196,233,241,1) 1%, rgba(250,250,250,1) 25%, rgba(250,250,250,1) 75%, rgba(196,233,241,1) 100%)',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    padding: '20px',
    textAlign: 'center',
    borderBottom: '10px solid #1356DA', // Borde solo en la parte inferior
    borderRadius: '8px', // Bordes redondeados en todo el card
  },
  cardImage: {
    maxWidth: '100%',
    height: 'auto',
    marginBottom: '10px', // Espacio debajo de la imagen
    borderRadius: '8px',
  },
  cardContent: {
    color: '#243C53',
    textAlign: 'start',
  },
  // Consulta de medios para pantallas de 1200px o menos
  '@media (max-width: 1200px)': {
    cardsContainer: {
      flexDirection: 'column',
      alignItems: 'center',
    },
    card: {
      width: '80%',
      marginBottom: '20px',
    },
  },
});

export default useStyles;